import styled, { css } from 'styled-components';
import { th } from 'style/theme';

export const SectionContainer = styled.div`
  ${({ $hideOverflow }) =>
    $hideOverflow &&
    css`
      overflow: hidden;
    `};
`;

export const SectionHeading = styled.h4`
  position: relative;
  font-size: 20px;
  margin: 24px 0 0 0;
`;

const lineStyle = css`
  content: ' ';
  position: absolute;
  top: 30%;
  right: 0;
  width: 14px;
  height: 2px;
  background-color: ${th('colors.black')};
  transition: transform 200ms;
`;

export const Toggle = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
  cursor: pointer;

  ::before {
    ${lineStyle};

    ${({ $isOpen }) =>
      !$isOpen &&
      css`
        transform: rotate(180deg);
      `};
  }

  ::after {
    ${lineStyle};

    ${({ $isOpen }) =>
      !$isOpen &&
      css`
        transform: rotate(90deg);
      `};
  }
`;
